export default {
  finishSection: 'finishSection',
  toggleExplanation: 'toggleExplanation'
}

